import React from 'react';

type SizeType = 'sm' | 'md';
type ColorType = 'gray' | 'error' | 'success';

type Props = {
  size?: SizeType;
  color?: ColorType;
  icon?: React.ReactNode;
};

const SIZE_CLASS: Record<SizeType, string> = {
  sm: 'h-3 w-3 min-w-3',
  md: 'h-[18px] w-[18px] min-w-[18px]',
};

const COLOR_CLASS: Record<ColorType, string> = {
  gray: 'bg-apps-coreGray03',
  error: 'bg-apps-coreProductError01',
  success: 'bg-apps-coreProductSuccess01',
};

/**
 * @param icon 12px 아이콘만 사용
 */
export default function BadgeIcon({
  size = 'sm',
  color = 'gray',
  icon,
}: Props) {
  return (
    <div
      className={`relative flex items-center justify-center rounded-full text-apps-coreGrayWhite ${SIZE_CLASS[size]} ${COLOR_CLASS[color]}`}
    >
      {icon}
    </div>
  );
}
